import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { DatePicker } from "formik-material-ui-pickers";
import React, { useEffect } from "react";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import { useDispatch, useSelector } from "react-redux";
import { getDepts } from "src/redux/actions/department.action";
import { getBrands } from "src/redux/actions/brand.action";
import { getYearList } from "src/redux/actions/purchaseRequest.action";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  formControl: {
    "& label span": {
      color: "red",
    },
  },
}));

export default function ReportSearchFormComponent({
  onSubmit,
  formValue,
  year,
  brand,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    result: { companyid, countryid, secureid },
  } = useSelector((state) => state.loginReducer);

  const departmentReducer = useSelector((state) => state.departmentReducer);

  const handleChangeBrand = (event) => {
    dispatch(getDepts(countryid, companyid, secureid, event.target.value));
  };

  const renderBrandItem = () => {
    if (brand === undefined || !brand.length) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return brand.map((item) => (
      <MenuItem key={item.ORG_BRAND_ID} value={item.ORG_BRAND_ID}>
        {item.BRAND}
      </MenuItem>
    ));
  };

  const renderDepartment = () => {
    if (departmentReducer.isFetching || !departmentReducer.result.length) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return departmentReducer.result.map((item) => (
      <MenuItem
        MenuItem={item.ORG_DEPARTMENT_ID}
        value={item.ORG_DEPARTMENT_ID}
      >
        {item.department}
      </MenuItem>
    ));
  };

  const renderYear = () => {
    if (year === undefined || !year.length) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return year.map((item) => (
      <MenuItem MenuItem={item.YEAR_CODE} value={item.YEAR_CODE}>
        {item.YEAR_CODE}
      </MenuItem>
    ));
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Formik
        enableReinitialize
        initialValues={formValue}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values);
          setSubmitting(false);
        }}
        validate={(values) => {
          const errors = {};

          if (!values.BUDGET_YEAR) {
            errors.BUDGET_YEAR = "Required";
          }

          if (!values.DATE_FROM) {
            errors.DATE_FROM = "Required";
          }
          if (!values.DATE_TO) {
            errors.DATE_TO = "Required";
          }

          return errors;
        }}
        render={({
          submitForm,
          resetForm,
          isSubmitting,
          setSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <Card>
            <CardContent className={classes.root}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} xs={12}>
                  <Box display="flex" justifyContent="center" m={1}>
                    <Box flexDirection="column" width={400}>
                      <Box mb={2}>
                        <FormControl
                          fullWidth
                          required
                          error={Boolean(
                            errors.BUDGET_YEAR &&
                              touched.BUDGET_YEAR &&
                              errors.BUDGET_YEAR
                          )}
                          className={classes.formControl}
                        >
                          <InputLabel id="select-year-label">
                            Budget Year
                          </InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="BUDGET_YEAR"
                            label="Year"
                            labelId="select-year-label"
                            size="small"
                            error={Boolean(
                              errors.BUDGET_YEAR &&
                                touched.BUDGET_YEAR &&
                                errors.BUDGET_YEAR
                            )}
                            helperText={
                              touched.BUDGET_YEAR && errors.BUDGET_YEAR
                            }
                            onChange={() => {}}
                          >
                            {renderYear()}
                          </Field>
                        </FormControl>
                      </Box>
                      <Box mb={2}>
                        <Field
                          required
                          component={DatePicker}
                          error={Boolean(
                            errors.DATE_FROM &&
                              touched.DATE_FROM &&
                              errors.DATE_FROM
                          )}
                          className={classes.formControl}
                          helperText={touched.DATE_FROM && errors.DATE_FROM}
                          fullWidth
                          label="Date From"
                          name="DATE_FROM"
                          format="dd/MM/yyyy"
                        />
                      </Box>
                      <Box mb={2}>
                        <Field
                          required
                          component={DatePicker}
                          className={classes.formControl}
                          fullWidth
                          label="Date To"
                          name="DATE_TO"
                          format="dd/MM/yyyy"
                        />
                      </Box>
                      {formValue.hasOwnProperty("PROJECT_CODE") && (
                        <Box mb={2}>
                          <Field
                            component={TextField}
                            name="PROJECT_CODE"
                            label="Project Code"
                            size="small"
                            fullWidth
                            error={Boolean(
                              errors.PROJECT_CODE &&
                                touched.PROJECT_CODE &&
                                errors.PROJECT_CODE
                            )}
                            helperText={
                              touched.PROJECT_CODE && errors.PROJECT_CODE
                            }
                          />
                        </Box>
                      )}
                      <Box mb={2}>
                        <FormControl fullWidth>
                          <InputLabel
                            shrink
                            htmlFor="BRANDID"
                            id="select-brand-label"
                          >
                            Brand
                          </InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="BRANDID"
                            label="Brand"
                            labelId="select-brand-label"
                            size="small"
                            onChange={handleChangeBrand}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>All</em>
                            </MenuItem>
                            {renderBrandItem()}
                          </Field>
                        </FormControl>
                      </Box>
                      <Box mb={5}>
                        <FormControl fullWidth>
                          <InputLabel
                            shrink
                            htmlFor="DEPARTID"
                            id="select-depart-label"
                          >
                            Department
                          </InputLabel>
                          <Field
                            component={CustomSelectInput}
                            name="DEPARTID"
                            label="Department"
                            labelId="select-depart-label"
                            size="small"
                            onChange={(e) => {}}
                            displayEmpty
                          >
                            <MenuItem value="">
                              <em>All</em>
                            </MenuItem>
                            {renderDepartment()}
                          </Field>
                        </FormControl>
                      </Box>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={(e) => {
                          e.preventDefault();
                          submitForm();
                        }}
                        disabled={isSubmitting}
                      >
                        Generate Report
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}
      />
    </MuiPickersUtilsProvider>
  );
}
